module.exports = __webpack_public_path__ + "img/nonglin.cc149bcf.jpg";